import '.d{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.a6{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.dg{background:var(--palette-white);}.ssr-plugin'
import '.eb{flex-grow:1;}.ssr-plugin'
import '.a5{align-items:center;}.ssr-plugin'
import '.at{max-width:77.5rem;}.ssr-plugin'
import '.eo{justify-content:stretch;}.ssr-plugin'
import '.bg{position:sticky;}.ssr-plugin'
import '.bh{top:0px;}.ssr-plugin'
import '.bl{z-index:10;}.ssr-plugin'
import '.ep{padding-block:1rem;}.ssr-plugin'
import '.eq{height:3rem;}.ssr-plugin'
import '.b4{justify-content:space-between;}.ssr-plugin'
import '.b6{flex-wrap:wrap;}.ssr-plugin'
import '.er{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.dn{margin-top:2rem;}.ssr-plugin'
import '.h1{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d ab a6 e dg"
      >
        <div className="eb d a5 a6 e"
        >
          <div className="at d e eo bg bh bl"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="ep eq d b4 a5 b6"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="er d e ab dn h1 at"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
